import { api, apiWidget } from "apiConnections";
import { AxiosRequestConfig } from "axios";

const requests = {
    translate: (config: AxiosRequestConfig) => api.get(`/translate`, config),
    settings: (config: AxiosRequestConfig) => apiWidget.get(`/games/settings`, config),
};

export default requests;
